// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__2vSPk","areaOfText":"Contact_areaOfText__2BxFF"};